import React from 'react';
import PropTypes from 'prop-types';
import BasketTotal from '../../BasketTotal';

import s from './index.module.scss';

const BasketSummary = ({ count = null }) => (
  <div className={s['basket-summary']}>
    Basket subtotal
    {count && (
      <span>
        {' '}
        ({count} {count === 1 ? 'item' : 'items'})
      </span>
    )}
    :{' '}
    <div className={s['basket-summary__amount']} data-component="basket-subtotal-amount">
      <BasketTotal />
    </div>
  </div>
);

BasketSummary.propTypes = {
  count: PropTypes.number,
  className: PropTypes.string,
};

export default BasketSummary;
